import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, Params, RouteReuseStrategy } from '@angular/router';

const retainComponentTreeDataKey = 'retainComponentTree';

@Injectable()
export class AzdeCertRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    return;
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  // Both destinations must opt in. Entering/leaving Staff and unmarked routes keep the existing recreation behavior.
  // Matching parameters retain the same screen; changing personId recreates Review while its Staff parent survives.
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return (
      future.routeConfig === curr.routeConfig &&
      this.haveSameParams(future.params, curr.params) &&
      this.belongsToRetainedComponentTree(future) &&
      this.belongsToRetainedComponentTree(curr)
    );
  }

  private belongsToRetainedComponentTree(route: ActivatedRouteSnapshot): boolean {
    // Descendants retain common app/lazy-route ancestors; pathFromRoot retains the marked parent during child changes.
    return (
      route.pathFromRoot.some((snapshot) => snapshot.data[retainComponentTreeDataKey] === true) ||
      this.hasRetainedDescendant(route)
    );
  }

  private hasRetainedDescendant(route: ActivatedRouteSnapshot): boolean {
    return (
      route.data[retainComponentTreeDataKey] === true ||
      route.children.some((child) => this.hasRetainedDescendant(child))
    );
  }

  private haveSameParams(future: Params, curr: Params): boolean {
    const futureKeys = Object.keys(future);
    const currentKeys = Object.keys(curr);
    return futureKeys.length === currentKeys.length && futureKeys.every((key) => future[key] === curr[key]);
  }
}
